import React, { Component } from 'react'
import Select from 'react-select-plus'
import { api } from 'app/modules/sfdc/api'
import SalesforceMeetingBookedBySelect from './SalesforceMeetingBookedBySelect'
import './style.styl'

const DEFAULT_LABEL = "Don't set type"
const UNKNOWN_ERROR = 'An unknown error occurred. If this problem persists, please chat with us.'
const DEFAULT_OPTION = { id: null, name: DEFAULT_LABEL }

const eventToSelectOption = (name) => ({
  id: name,
  name
})

class SalesforceEventMapping extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      hasError: false,
      selectValue: null,
      selectLabel: null,
      selectOptions: []
    }
  }

  componentDidMount() {
    this.getInitialValue()
  }

  getInitialValue = () => {
    const promises = [
      api.getSalesforceEventTypeList(),
      api.getSalesforceEventType()
    ]

    const onDone = ([eventTypes, eventType]) => {
      this.setState({
        isLoading: false,
        selectOptions: eventTypes.map(eventToSelectOption),
        selectValue: eventType
      })
    }

    Promise.all(promises)
      .then(onDone)
      .catch(this.handleUnknownError)
  }

  handleUnknownError = () => {
    this.setState({
      isLoading: false,
      hasError: true,
      errorText: UNKNOWN_ERROR
    })
  }

  onChange = ({ id, name }) => {
    const onDone = () => {
      this.setState({ isLoading: false })
    }
    
    const patch = api.patchSalesforceEventType({ eventType: id })
      .then(onDone)
      .catch(this.handleUnknownError)

    this.setState({
      selectValue: id,
      selectLabel: name,
      isLoading: true
    }, patch)
  }

  resolveSelectOptions = () => {
    const { selectOptions } = this.state
    return [DEFAULT_OPTION, ...selectOptions]
  }

  render() {
    const { hasError, errorText, selectValue, selectLabel, isLoading } = this.state
    const options = this.resolveSelectOptions()

    return (
        <div className="salesforce-activity-select-container">
      
        <Select
          className="salesforce-activity-select-input"
          labelKey="name"
          valueKey="id"
          autosize={false}
          searchable={false}
          clearable={false}
          placeholder={DEFAULT_LABEL}
          value={selectValue}
          label={selectLabel}
          options={options}
          isLoading={isLoading}
          onChange={this.onChange}
          resetValue={DEFAULT_OPTION}
        />
        <SalesforceMeetingBookedBySelect />
        {hasError &&
          <p className="salesforce-task-error-text">
            {errorText}
          </p>
        }
      </div>
    )
  }
}

export default SalesforceEventMapping


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceConfig/SalesforceEventDataMapping.js